export enum DataSpacePermission {
  WRITE = 'WRITE',
  READ = 'READ',
  VISUALIZATION = 'VISUALIZATION',
  CUSTOM = 'CUSTOM'
}

export const DATA_SPACE_PERMISSION_LEVELS: readonly DataSpacePermission[] = [
  DataSpacePermission.WRITE,
  DataSpacePermission.READ,
  DataSpacePermission.VISUALIZATION,
  DataSpacePermission.CUSTOM
] as const;
